import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// ✅ helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    const jsonData = JSON.parse(data);
    jsonData.subTenantDTO = { id: decodedToken.subTenantId };
    return JSON.stringify(jsonData);
  }
  return data;
};

// ✅ helper: construct headers dynamically
const constructHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") ||
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const SubtenantApi = {
  // Create subtenants Api
  Createsubtenants: (data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();

    return new Promise((resolve, reject) => {
      apiApp
        .post(`/subtenant`, data, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data));
    });
  },

  // Single subtenants Api
  SingleSubtenantsApi: () => {
    // data = injectSubTenantId(data);
    const headers = constructHeaders();
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/subtenant/${decodedToken?.subTenantId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data));
    });
  },

  // Put subtenant Api
  PutSubtenant: (subtenantID, data) => {
    data = injectSubTenantId(data);
    const headers = constructHeaders();
    return new Promise((resolve, reject) => {
      apiApp
        .put(`/subtenant/${subtenantID}`, data, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data));
    });
  },

  // List subtenants Api
  subtenantsList: (tenantId) => {
    // data = injectSubTenantId(data);
    const headers = constructHeaders();
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/subtenants/${tenantId}?size=100&tenantId=${tenantId}${getSubTenantIdParam()}`,
          { headers }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data));
    });
  },

  // Delete subtenants Api
  DeletesubtenantsApi: (subtenantID) => {
    // data = injectSubTenantId(data);
    const headers = constructHeaders();
    return new Promise((resolve, reject) => {
      apiApp
        .delete(
          `/subtenant/${subtenantID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data));
    });
  },

  // add whitel;osted ips
  AddWhiteListedIPs: (data) => {
    return new Promise((resolve, reject) => {
      apiApp
        .patch(`/subtenant/${decodedToken?.subTenantId}/whitelisted-ips`, data, { headers: constructHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data || error.message));
    });
  },
};

export default SubtenantApi;
